export const DIR = 'http://localhost:3000/';
export const CDN = 'https://b-cdn.fragnet.net/';
export const BILLING = 'https://clients.fragnet.net/';